import React, { useEffect, useState } from 'react';
import { CreatePostingJob, PostingJob, SetLoading } from '../Classes';
import { Button, Field, Input, Message } from 'react-frontier';
import { bindFormChange } from '@tempu/components/Util';
import { Dropdown } from 'semantic-ui-react';
import API from '../API';
import Modal from './Modal';
import Validator from '@tempu/components/Validator';
import moment from 'moment';

interface ModalProps {
	open: boolean,
	posting_id: number,
	showPostings?: boolean,
	onClose: () => void,
	onJobCrated?: (jobInfo: PostingJob) => void,
}

var blankForm: CreatePostingJob = {
	job_name: null,
	job_count: null,
	rate_type: null,
	pay_rate: null,
	description: null,
	date_end: null,
	date_start: null
}

var CreateJobModal = (props: ModalProps) => {
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [jobForm, setJobForm] = useState<CreatePostingJob>(blankForm);
	var [selectedPosting, setSelectedPosting] = useState<number>(null);

	var create = async(setLoading: SetLoading)=>{
		var { valid, prompts } = Validator(jobForm, {
			job_name: [{
				rule: 'minLength', params: [3], label: 'Nombre de puesto'
			}],
			job_count: [{
				rule: 'number', params: [1, 999], label: 'Vacantes'
			}],
			rate_type: [{
				rule: 'number', label: 'Frecuencia'
			}],
			pay_rate: [{
				rule: 'number', label: 'Sueldo'
			}],
			description: [{
				rule: 'minLength', params: [3], label: 'Descripcion'
			}],
			date_start: [{
				rule: 'empty', label: 'Fecha inicio'
			}],
			date_end: [{
				rule: 'empty', label: 'Fecha fin'
			}],
		});
		setModalPrompts(prompts);
		if(!valid) return;
		if(jobForm.date_end < jobForm.date_start) return setModalPrompts(['La fecha fin debe ser mayor a la fecha inicio.']);
		setLoading(true);
		API.createPostingJob(selectedPosting || props.posting_id, jobForm).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			
			setJobForm(blankForm);
			setSelectedPosting(null);
			if (props.onJobCrated) {
				props.onJobCrated({
					posting_id: props.posting_id,
					job_name: jobForm.job_name,
					job_count: jobForm.job_count,
					job_id: res.data.job_id,
					description: jobForm.description,
					rate_type: jobForm.rate_type,
					pay_rate: jobForm.pay_rate,
					deleted: false,
					published: false,
					date_created: moment().unix(),
					date_start: jobForm.date_start,
					date_end: jobForm.date_end
				});
			}
		}).catch(err=>{
			setModalPrompts(['Hubo un error al crear el puesto. (PJC-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	var onEditForm = bindFormChange(jobForm, setJobForm);

	return <Modal open={props.open} size='tiny' onClose={props.onClose}>
		<Modal.Header>Crear puesto</Modal.Header>
		<Modal.Content>
			<Field amount={2}> 
				<Input label='Nombre de puesto' value={jobForm.job_name} onChange={onEditForm('job_name')}/>
				<Input label='Vacantes' value={jobForm.job_count} onChange={onEditForm('job_count')}/>
			</Field>
			<Field amount={2}>
				<Input label='Sueldo' placeholder='Ingesa el sueldo' value={jobForm.pay_rate} onChange={onEditForm('pay_rate')}/>
				<Field label='Frecuencia'>
					<Dropdown selection value={jobForm.rate_type} onChange={onEditForm('rate_type', true)} placeholder='Selecciona la frecuencia' options={[
						{ value: 10, text: 'Hora' },
						{ value: 20, text: 'Diario' },
						{ value: 1, text: 'Fijo' },
					]} />
				</Field>
			</Field>
			<Field amount={2}>
				<Input 
					label='Fecha inicio' 
					style={{ width: '100%'}} 
					value={jobForm.date_start} 
					onChange={onEditForm('date_start')} 
					calendar={{ 
						date: jobForm.date_start || moment().unix(), 
						mode: 'datetime', 
					}} />
				<Input 
					label='Fecha fin' 
					style={{ width: '100%'}} 
					value={jobForm.date_end} 
					onChange={onEditForm('date_end')} 
					calendar={{ 
						date: jobForm.date_end || moment().unix(), 
						mode: 'datetime', 
					}} />
			</Field>
			<Input label='Descripción' value={jobForm.description} onChange={onEditForm('description')} textarea/>
			<Message type="error" list={modalPrompts} />
		</Modal.Content>
		<Modal.Actions>
			<Button text='Cancelar' basic onClick={props.onClose}/>
			<Button text='Crear' color='black' onClick={create}/>
		</Modal.Actions>
	</Modal>
}	

export default CreateJobModal;